import React from 'react';
import { Heart, Mail, Phone, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
const Footer = () => {
  const {
    t
  } = useTranslation();
  const currentYear = new Date().getFullYear();
  return <footer className="bg-charcoal text-white py-12" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-347">
          <div data-id="element-348">
            <div className="flex flex-col" data-id="element-349">
              <h2 className="text-2xl font-semibold" data-id="element-350">MONA</h2>
              <p className="text-xs text-grey-400" data-id="element-351">{t('footer.credentials')}</p>
            </div>
          </div>
          <div className="mt-4 md:mt-0" data-id="element-352">
            <div className="flex space-x-4" data-id="element-353">
              <a href="#" className="text-grey-400 hover:text-sage-mint transition-colors duration-300" data-id="element-354">
                {t('footer.privacy')}
              </a>
              <a href="#" className="text-grey-400 hover:text-sage-mint transition-colors duration-300" data-id="element-355">
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-grey-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-356">
          <p className="text-sm text-grey-400" data-id="element-357">
            {t('footer.copyright', {
            year: currentYear
          })}
          </p>
          <div className="mt-4 md:mt-0 flex items-center" data-id="element-358">
            <span className="text-sm text-grey-400 flex items-center" data-id="element-359">
              Made with <Heart className="h-3 w-3 text-coral-pink mx-1" data-id="element-360" /> in
              Singapore
            </span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;